
<template>
  <b-input-group
      :key="'subInput-' + reload"
      class="agInputGroup agSubInput"
      :size="size"
      :prepend="prepend">
      <label v-if="label">
          {{label}}
      </label>
      <b-form-textarea
          v-if="type == 'textarea'"
          ref="input"
          v-model="text"
          :disabled="disabled"
          :placeholder="placeholder"
          :rows="rows"
          :maxRows="maxRows"
          @focus="input_focus"
          @blur="input_blur"
          @keyup="input_keyup"
          @keyup.enter.native.stop>
      </b-form-textarea>
      <b-input 
          v-else
          ref="input"
          v-model="text"
          @input="onChange"
          autocomplete="false"
          :disabled="disabled"
          :placeholder="placeholder"
          @focus="input_focus"
          @blur="input_blur"
          @keyup="input_keyup">
      </b-input>
      <span
          ref="hidden"
          class="agSubInput-hidden">
          {{hiddenText}}
      </span>
      <b-list-group
      v-if="isShowing"
      class="agSubInput-fields"
      :style="{'left': positionX + 'px', 'top': positionY + 'px'}">
      <b-list-group-item 
          v-for="(input, key) in fields" 
          :key="key"
          class="agSubInput-fieldHeader">
          {{key}}
          <b-list-group>
              <b-list-group-item 
                  v-for="(item, index) in input"
                  :key="key + '-' + index"
                  class="agSubInput-fieldItem"
                  :class="{'agSubInput-noFieldsItem': item.field == 'No fields available'}"
                  :button="true"
                  @click="fieldItem_click($event, item)">
                  <span v-if="item.alias">{{item.object}} ({{item.alias}})</span>
                  <span v-else>{{item.field}}</span>
              </b-list-group-item>
          </b-list-group>
      </b-list-group-item>
    </b-list-group>
    <button
      v-if="appendButton"
      class="agTextButton agInputGroup-append"
      @click="button_click"
    >{{buttonText}}</button>
  </b-input-group>
</template>






<script>
// components

// modules
import Util from "src/util/util";

export default {
    name: "ag-sub-input",
    components: {

    },
    props:{
        initText: String, 
        type: String,
        workflow: Object,
        disabled: Boolean,
        placeholder: String,
        size: String,
        prepend: String,
        rows: Number,
        maxRows: Number,
        noResize: Boolean,
        label: String,
        appendButton: Boolean,
        buttonText: String

    },
    data(){
        return {
            reload: 0,
            text: this.initText,
            isShowing: false,
            hiddenText: "",
            currentSubIndex: 0,
            positionX: 0,
            positionY: 35,
        };
    },

    computed: {
      fields() {
        var allFields = Util.getInputFields(this.$store, this.workflow);
        var funcFields = { "Functions": [
            {object: "VAR", field: "EMPTY", alias: "Empty"},
            {object: "VAR", field: "NULL", alias: "Null"},
            {object: "NOW", field: "STRINGDATE", alias: "Date"},
            {object: "NOW", field: "STRINGDATETIME", alias: "DateTime"},
            {object: "NOW", field: "EPOCH", alias: "Epoch"},
            {object: "NOW", field: "STRINGTIME", alias: "Time"}
        ]};
        Object.assign(allFields, funcFields);

        // build filter text
        if(this.currentSubIndex > -1) {
            var lineNum = this.getCurrentLine();
            var lineText = this.getTextForLine(lineNum);
            for(var i = this.currentSubIndex + 2; i < lineText.length; i++) {
                var char = lineText.charAt(i);
                if(char == "}") {
                    var subEnd = i;
                    var filterText = lineText.substring(this.currentSubIndex + 2, subEnd);
                    break;
                }
                else if(i == this.text.length - 1) {
                    var filterText = lineText.substring(this.currentSubIndex + 2, lineText.length);
                    break;
                }
            }
        }

        // now filter based on text
        if(filterText) {    
          var filterTexts = filterText.split(".");
          var filtered = {};
          var keys = Object.keys(allFields);
          for(var i = 0; i < keys.length; i++) {
              var key = keys[i]
              var fields = allFields[key];
              var filteredFields = [];
              for(var j = 0; j < fields.length; j++) {
                  var field = fields[j];
                  if(filterTexts.length == 1) {
                      var filter = filterTexts[0];
                      if(field.object.toLowerCase().indexOf(filter.toLowerCase()) > -1 || field.field.toLowerCase().indexOf(filter.toLowerCase()) > -1)
                          filteredFields.push(field);
                  }
                  else {
                      var filterObj = filterTexts[0];
                      var filterField = filterTexts[1];
                      if(field.object.toLowerCase().indexOf(filterObj.toLowerCase()) > -1 && field.field.toLowerCase().indexOf(filterField.toLowerCase()) > -1)
                          filteredFields.push(field);
                  }
              }
              if(filteredFields.length > 0)
                  filtered[key] = filteredFields;
          }
          allFields = filtered;
        }
          
      if(Object.keys(allFields).length == 0) {
          allFields[" "] = [
              {object: null, field: "No fields available"}
          ];
      }

      return allFields;
    }
  },

  watch: {
    initText() {
      this.text = this.initText;
    }
  },

  created() {},

  mounted() {

  },

  methods: {
    onChange(){
      this.$emit('input', this.text)
    },
    // UI Events
    input_focus() {
      // needs slight delay for cursor position
      setTimeout(() => {
        this.checkForSub();
      }, 250);
    },

    input_blur() {
      // needs slight delay to trigger the click event when a field is selected
      setTimeout(() => {
        this.isShowing = false;
      }, 250);
    },

    input_keyup() {
      this.$emit("change");
      this.checkForSub();
    },

    fieldItem_click(e, item) {
      if (item.field == "No fields available") return;

      var subText = "${" + `${item.object}.${item.field}` + "}";
      var lineNum = this.getCurrentLine();
      var lineText = this.getTextForLine(lineNum);
      for (var i = this.currentSubIndex + 1; i < lineText.length; i++) {
        var char = lineText.charAt(i);
        if (char == "}") {
          var subEnd = i;
          var part1 = lineText.substring(0, this.currentSubIndex);
          var part2 = lineText.substring(subEnd + 1, lineText.length);
          lineText = part1 + subText + part2;
          break;
        } else if (i == lineText.length - 1) {
          var subEnd = i;
          var part1 = lineText.substring(0, this.currentSubIndex);
          lineText = part1 + subText;
          break;
        }
      }

      // now replace line in the main text and move the cursor
      var lines = this.text.split("\n");
      lines[lineNum - 1] = lineText;
      this.text = "";
      var cursor = 0;
      for (var i = 0; i < lines.length; i++) {
        var newLine = lines[i];
        if (i == lines.length - 1) this.text += newLine;
        else this.text += newLine + "\n";

        if (i == lineNum - 1) cursor += newLine.length;
        else if (i < lineNum) cursor += newLine.length + 1; // \n
      }

      // finally, refocus input
      setTimeout(() => {
        this.$emit("change");
        var input = this.$refs["input"];
        input.selectionStart = cursor;
        input.focus();
      }, 250);
    },

    button_click() {
      this.$emit("buttonClick");
    },

    // Emmitted events

    // other

    checkForSub() {
      if (!this.text) {
        this.hideFields();
        return;
      } else if (this.text == "${") {
        this.showFields();
        return;
      }

      var input = this.$refs["input"];
      var cursor = input.selectionStart;
      var lineNum = this.getCurrentLine();
      this.positionY = (lineNum - 1) * 24.0 + 35.0;
      var lineText = this.getTextForLine(lineNum);
      var remainingText = lineText;
      var subStart = remainingText.indexOf("${");
      this.currentSubIndex = subStart;
      while (subStart > -1) {
        // if entire string remaining is "${" show the fields
        if (remainingText == "${") {
          this.showFields();
          return;
        }

        // loop through each character after "${" and lookg for closing brace or end of string
        for (var i = subStart + 1; i < remainingText.length; i++) {
          var char = remainingText.charAt(i);
          // end of sub
          if (char == "}") {
            var subEnd = i;
            // if cursor is within sub show fields
            if (cursor > subStart && cursor <= subEnd) {
              this.currentSubIndex =
                lineText.length - remainingText.length + subStart;
              this.showFields();
              return;
            }

            // remove first sub
            remainingText = remainingText.substring(
              subEnd + 1,
              remainingText.length
            );
            // find next sub in the new string
            subStart = remainingText.indexOf("${");
            // remove any non-sub text before the new sub
            remainingText = remainingText.substring(
              subStart,
              remainingText.length
            );
            // adjust the substart for the new string
            subStart = remainingText.indexOf("${");
            // adjust the cursor value for the removed parts of the string
            cursor -= this.text.length - remainingText.length;
            // keep track of the actual index of this sub
            this.currentSubIndex =
              lineText.length - remainingText.length + subStart;

            break;
          }
          // end of text
          else if (i == remainingText.length - 1) {
            if (cursor >= subStart) {
              this.currentSubIndex =
                lineText.length - remainingText.length + subStart;
              this.showFields();
              return;
            }
            this.hideFields();
            return;
          }
        }
      }
      this.hideFields();
    },

    showFields() {
      var input = this.$refs["input"];
      var hidden = this.$refs["hidden"];
      var lineNum = this.getCurrentLine();
      var lineText = this.getTextForLine(lineNum);
      this.hiddenText = lineText.substring(0, this.currentSubIndex + 1);

      // needs time for width of hidden to adjust to new hiddenText value
      setTimeout(() => {
        var maxPositionX = input.$el.offsetLeft + input.$el.clientWidth - 300;
        if (maxPositionX < 0) 
          maxPositionX = 0;

        var newPositionX = input.$el.offsetLeft + hidden.clientWidth;
        if (newPositionX < maxPositionX) 
          this.positionX = newPositionX;
        else 
          this.positionX = maxPositionX;

        this.isShowing = true;
      }, 250);
    },

    hideFields() {
      this.isShowing = false;
    },

    getCurrentLine() {
      if (this.type != "textarea") {
        return 1;
      }

      var input = this.$refs["input"];
      var cursor = input.selectionStart;

      // if textrarea, narrow down remainingText to a single line
      var lines = this.text.split("\n");
      var length = 0;
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        var nextLength = length + line.length + 1; // each line also has a \n character that was split out
        if (cursor > length && cursor <= nextLength) {
          return i + 1;
        }
        length = nextLength;
      }
      return 1;
    },

    getTextForLine(lineNum) {
      var lines = this.text.split("\n");
      if (lines.length > lineNum - 1) return lines[lineNum - 1];
      return this.text;
    }
  }
};
</script>






<style scoped lang="css">
.agSubInput-hidden {
  position: absolute;
  visibility: hidden;
  top: -30px;
}

.agSubInput-fields {
  position: absolute;
  max-height: 300px;
  overflow: auto;
  z-index: 100;
  text-align: left;

  border-width: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: lightgray;
}

.agSubInput-fieldHeader {
  font-weight: bold;
  color: gray;
}

.agSubInput-fieldHeader .list-group {
  margin-top: 5px;
}

.agSubInput-fieldItem {
  font-weight: normal;
  border-radius: 0;
  border-width: 1px 0 0 0;
  cursor: pointer;
}

.agSubInput-fieldItem:hover {
  background-color: #e9ecef;
}

.agSubInput-noFieldsItem {
  cursor: not-allowed;
}

.agSubInput-noFieldsItem:hover {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/SubInput.vue